import { NotFoundError } from '@cian/peperrors/shared';

import { type TCianApiSiteV1FilterPikNewbuildingsResponse } from 'shared/repositories/monolith-python/cian-api/site/v1/filter-pik-newbuildings';

export const assertNotFoundError = (response: TCianApiSiteV1FilterPikNewbuildingsResponse): void => {
  if (response.statusCode === 200) {
    return;
  }

  throw new NotFoundError({
    domain: 'src/shared/services/getFilteredResidentialComplexes/assert/assertNotFoundError.ts',
    message: 'Empty newbuilding data',
  });
};
